import constants from '#packages/constants';

export default {
  verticallyResizable: false,
  duplicatable: false,
  disabledKnobs: () => Object.values(constants.RESIZE_SIDES),
};
